module.exports = __webpack_public_path__ + "img/bonus10.9c5888dc.png";